/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ summary: NonNullable<unknown>, value: NonNullable<unknown> }} Ui_Laps_Efforts_ChipInputs */

const en_ui_laps_efforts_chip = /** @type {(inputs: Ui_Laps_Efforts_ChipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.summary} · ${i?.value}`)
};

const de_ui_laps_efforts_chip = /** @type {(inputs: Ui_Laps_Efforts_ChipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.summary} · ${i?.value}`)
};

/**
* | output |
* | --- |
* | "{summary} · {value}" |
*
* @param {Ui_Laps_Efforts_ChipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_efforts_chip = /** @type {((inputs: Ui_Laps_Efforts_ChipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Efforts_ChipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_efforts_chip(inputs)
	return de_ui_laps_efforts_chip(inputs)
});